import SyfStorage from '../../helpers/SyfStorage';
var currentLanguage = SyfStorage.getLanguage();
export var analyticsHelper = Object.freeze({
    defaults: {
        COUNTRY_LANGUAGE: "us|".concat(currentLanguage),
        PAGE_NAME: 'view',
        PAGE_KIND: 'alerts',
        SITE_IDENTIFIER: 'vista',
        PNL: 'vista',
        CUSTOMER_TYPE: 'consumer',
        PRODUCT: 'generic' // Currently we don't have this info
    },
    // TODO map this out specifically, for now just use the home page stuff
    pageEvents: {
        DEFAULT: {
            PAGE_FUNCTION: 'alerts',
            NAME: 'view',
            PAGE_KIND: 'alerts'
        },
        ALERTS: {
            PAGE_FUNCTION: 'alerts',
            NAME: 'view',
            PAGE_KIND: 'alerts'
        },
        ERROR: {
            PAGE_FUNCTION: 'error',
            NAME: 'view',
            PAGE_KIND: 'alerts'
        },
        NOT_AVAILABLE: {
            PAGE_FUNCTION: 'alerts',
            NAME: 'notavailable',
            PAGE_KIND: 'alerts'
        },
        PREFERENCE_CENTER: {
            PAGE_FUNCTION: 'preference settings',
            NAME: 'view',
            PAGE_KIND: 'marketing & privacy'
        }
    },
    device: {
        DESK: 'desk',
        MOBI: 'mobile',
        TAB: 'tab'
    },
    channels: {
        VISTA: 'vista'
    },
    siteIdentifier: {
        'digital-servicing': 'vista',
        'digital-servicing-pre-login': 'peaks'
    },
    pnl: {
        'digital-servicing': 'vista',
        'digital-servicing-pre-login': 'peaks'
    }
});
export var DATA_SUBFUNCTION = {
    SMS_BANNER: {
        TERMS_CONDITIONS_SAVE_BTN: "sms consent|modify"
    }
};
export var DATA_REASON = {
    SMS_BANNER: {
        TERMS_CONDITIONS_SAVE_BTN: "sms consent:save"
    },
    ACCOUNTS_DROPDOWN: 'selectaccount',
    SAVE: 'save',
    CANCEL: 'cancel',
    EDIT: 'edit',
    PRIVACY_CHECKBOX: 'don’t share information',
    PRIVACY_POLICY_LINK: 'review privacy policy',
    CONTACT_INFORMATION_LINK: 'update contact information'
};
export var DATA_OBJECT = {
    BUTTON: 'button',
    LINK: 'link',
    DROPDOWN: 'button',
    ACCORDION: 'accordion',
    CHECKBOX: {
        CHECKED: 'checked',
        UNCHECKED: 'unchecked'
    }
};
export var DATA_TYPE = {
    BUTTON: 'button',
    LINK: 'link',
    DROPDOWN: 'dropdown',
    MARKETING_PRIVACY_SETTINGS: 'marketing & privacy settings',
    PRIVACY_SETTINGS: 'privacy settings'
};
export var CLICK_TRACKING_EVENT = 'clicktrackingevent';
export var ENROLL_ALERT = {
    DAYS: 'days',
    AMOUNT: 'amount'
};
